import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11 20.167a9.167 9.167 0 1 0-8.322-5.32c.428.924.833 1.712.534 2.75-.143.5-.503.993-.546 1.513a.917.917 0 0 0 1.064.98c1.2-.2 1.777-1.154 3.168-.827.151.036.544.176 1.33.457.832.298 1.728.447 2.772.447Z"
    />
    <path
      fill="currentColor"
      d="m11 7.333 1.037 2.63L14.667 11l-2.63 1.037L11 14.667l-1.037-2.63L7.333 11l2.63-1.037L11 7.333Z"
    />
  </svg>
)
export default SvgComponent
